<template>
  <div class="baiduQueue">
      <div class="head">
        <img src="/static/index/index12.png" alt="">
        <div class="title">
            <div class="h1">因为专业·所以信赖</div>
            <div class="h2">工程师专业答疑，为你解惑。所有工程师均获得《xxxxxx证书》</div>
        </div>
        <div class="search">
          <div class="s1"><el-cascader placeholder="区域" :options="options" v-model="selectedOptions" @change="handleChangeData" :props="props"></el-cascader></div>
          <div class="s1">
              <img src="/static/index/index11.png" alt="">
              <el-input v-model="input"  @keyup.enter.native="getData" placeholder="工程师名称"></el-input>
          </div>
          <div class="s2" @click="getData">查询</div>
      </div>
      </div>
      
      <h1>Consulting Engineer</h1>
      <h2>咨询工程师</h2>
      <div class="label">
          <div :class="index==1?'l1':''" @click="update(1)">现场工程师</div>
          <div :class="index==2?'l1':''" @click="update(2)">电话工程师</div>
          <div :class="index==3?'l1':''" @click="update(3)">销售工程师</div>
      </div>
      <div class="box">
          <div @click="jump(item)" v-for="(item,index) in treeList" :key="index">
              <div class="b1"><img :src="item.avatarUrl?item.avatarUrl:'/static/index/index16.png'" alt=""></div>
              <div class="b2">{{item.fullName}}</div>
              <div class="b3">
                  <img v-for="(item,index) in 5" :key="index" src="/static/index/index13.png" alt="">
                  <!-- <img v-for="(item,index) in 1" :key="index" src="/static/index/index14.png" alt=""> -->
              </div>
              <div class="b4">工作时间：{{item.workTime}}</div>
              <div class="b4">服务区域：{{item.ranges}}</div>
              <div class="b4">服务设备：{{item.remark}}</div>
              <div class="b5">
                  <div v-for="(item2,index2) in item.idsList" :key="index2">{{item2}}</div>
              </div>
          </div>
          
      </div>
      <el-pagination
      background
        layout="prev, pager, next"
        :page-size="12"
        @current-change="pageChange"
        :total="allPage">
    </el-pagination>
    <footer1></footer1>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { regionData } from "element-china-area-data";
if(regionData[0].label=='北京市'){
    regionData.unshift({label:'全部',value:'000000',children:[{label:'全部',value:'000000',children:[{label:'全部',value:'000000'}]}]})
}

export default {
  title: "课程列表",
  data() {
    return {
    options: regionData,
    selectedOptions:[],
    props:{
        value:'label',
        label:'label'
    },
      input:'', // 搜索产品输入
        treeList:[],
        chooseCity:[],
        page:1,
        allPage:0,
        index:1
    };
  },
  computed: {},
  components: {},
  methods: {
      update(e){
            this.index=e
            this.input=null
            this.empty()
        },
        empty(){
            this.page=1
            this.treeList=[]
            this.allPage=0
            this.getData()
        },
      jump(e){
          this.$router.push({
              path:'/engineerDetail',
              query:{
                  id:e.eid
              }
          })
      },
      handleChangeData(value) {
          if(value[0]=="全部"){
              this.chooseCity=[]
              this.selectedOptions=[]
          }else{
              this.chooseCity=value
          }
          this.getData()
    },
    pageChange(e){
        this.page=e
        this.getData()
    },
    getData() {
      var data = {
            crud: 2,
            engineerJson:JSON.stringify({
                typeId:this.index,
                // aid:uni.getStorageSync('aid'),
                fullName:this.input,
                ranges:this.chooseCity.length==0?null:this.chooseCity[1]!='市辖区'?this.chooseCity[1]:this.chooseCity[0]
            }),
            page:this.page,
            size:12	
        }
        this.$axios.post('/do_oper_engineer', this.$qs.stringify(data)).then(res => {
            this.treeList=res.data.data.list
            for(let i=0;i<this.treeList.length;i++){
                this.treeList[i].idsList=this.treeList[i].ids.split(',')
                if(this.treeList[i].idsList.length>3){
                    this.treeList[i].idsList.splice(3,this.treeList[i].idsList.length-3)
                }
            }
            this.allPage=res.data.data.allCounts
        })
    },
  },

  mounted() {
    this.getData();  
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  height: 100%;
  overflow-y: auto;
//   display: flex;
//   flex-direction: column;
//   padding-bottom: 50px;
  .head{
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &>img{
        width: 100%;
        height: 100%;
        position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }
    .title{
        width: 1200px;
        z-index: 1;
        .h1{
            font-size: 50px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 44px;
        }
        .h2{
            font-size: 30px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            width: 530px;
        }
    }
    .search{
      width: 1200px;
      height: 135px;
    background: #85A9CD;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 377px;
    transform: translate(-50%,0);
    display: flex;
    align-items: center;
    justify-content: center;
    .s1{
        width: 382px;
        height: 66px;
        border-radius: 6px;
        border: 3px solid #FFFFFF;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        /deep/ .el-input__inner{
            border: none;
            background: transparent;
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            &::placeholder {
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            }
        }
        /deep/ .el-input__icon{
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
        }
        &>img{
            width: 24px;
            height: 24px;
        }
        &>.el-input{
            width: 60%;
        }
        
    }
    .s2{
        width: 222px;
        height: 66px;
        background: #FFFFFF;
        border-radius: 6px;
        text-align: center;
        line-height: 66px;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #0457AD;
    }
  }
  }
  
  h1{
      font-size: 40px;
    font-family: BanglaMN;
    color: #999999;
    text-align: center;
    margin-top: 73px;
  }
  h2{
      font-size: 40px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #666666;
        text-align: center;
        margin-bottom: 50px;
  }
  .label{
      display: flex;
      align-items: center;
      width: 1200px;
      margin: 0 auto;
        div{
            width: 160px;
            height: 50px;
            background: #FFFFFF;
            border-radius: 33px;
            text-align: center;
            line-height: 50px;
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            margin-right: 10px;
        }
        .l1{
            background: #198AFA;
            color: #FFFFFF;
        }
  }
  .box{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      &>div{
          width: 370px;
        height: 258px;
        padding-top: 80px;
        background: #FFFFFF;
        margin-right: 45px;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        margin-top: 120px;
        position: relative;
        .b1{
            width: 160px;
            height: 160px;
            background: #F6F6F6;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
            border: 7px solid #FFFFFF;
            position: absolute;
            left: 50%;
            top: -50%;
            transform: translate(-50%,50%);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            img{
                width: 122px;
                height: 122px;
            }
        }
        .b2{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
            margin-bottom: 11px;
            text-align: center;
        }
        .b3{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
            img{
                width: 14px;
                height: 13px;
                margin-right: 3px;
            }
        }
        .b4{
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #666666;
            text-align: left;
            padding: 0 50px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        .b5{
            display: flex;
            justify-content: center;
            margin-top: 20px;
            div{
                // width: 90px;
                padding: 0 5px;
                height: 32px;
                border-radius: 6px;
                border: 1px solid #0457AD;
                text-align: center;
                line-height: 32px;
                font-size: 20px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #0457AD;
                margin-right: 10px;
            }
        }
      }
      &>div:nth-child(3n){
          margin-right: 0;
      }

  }
}
.el-pagination{
    text-align: center;
    margin-top: 36px;
    margin-bottom: 20px;
    /deep/ .el-pager li,/deep/ .btn-next,/deep/ .btn-prev{
        background: transparent;
    }
    /deep/ .el-pager li:not(.disabled).active{
        border-radius: 50%;
        background: #88C0F8;
    }
}
</style>  


// WEBPACK FOOTER //
// src/pages/engineer/index.vue